@if (form(); as form) {
  <fieldset [formGroup]="form">
    <legend>
      Powiadomienia
    </legend>
    <div class="row">
      @for (topic of form.topics; track $index) {
        <div class="col-12">
          <p class="mb-3">
            <strong>
              {{ topic | topicNameByCode }}
            </strong>
          </p>
          <ul [formGroupName]="topic" class="row">
            <li class="col-md-2">
              <div class='form-group d-inline-block' *ngIf='"sms" as controlName'>
                <div class='custom-checkbox custom-inline'>
                  <input
                    [formControlName]='controlName'
                    type='checkbox'
                    [id]='controlName + "_" + topic'
                    [name]='controlName + "_" + topic'>
                  <label [for]='controlName + "_" + topic'>
                    SMS
                  </label>
                </div>
              </div>
            </li>
            <li class="col-md-2">
              <div class='form-group d-inline-block' *ngIf='"email" as controlName'>
                <div class='custom-checkbox custom-inline'>
                  <input
                    [formControlName]='controlName'
                    type='checkbox'
                    [id]='controlName + "_" + topic'
                    [name]='controlName + "_" + topic'>
                  <label [for]='controlName + "_" + topic'>
                    E-mail
                  </label>
                </div>
              </div>
            </li>
            <li class="col-md-5">
              <div class='form-group d-inline-block' *ngIf='"push" as controlName'>
                <div class='custom-checkbox custom-inline'>
                  <input
                    [formControlName]='controlName'
                    type='checkbox'
                    [id]='controlName + "_" + topic'
                    [name]='controlName + "_" + topic'>
                  <label [for]='controlName + "_" + topic'>
                    Push (w aplikacji mobilnej)
                  </label>
                </div>
              </div>
            </li>
          </ul>
          @if (topic === 'waste') {
            <app-waste-area-form [form]="form.areaForm">
            </app-waste-area-form>
          }
        </div>
      }
    </div>
  </fieldset>
}
